import { render, staticRenderFns } from "./NotifyWizardStepTwo.vue?vue&type=template&id=36371f87&scoped=true&"
import script from "./NotifyWizardStepTwo.vue?vue&type=script&lang=js&"
export * from "./NotifyWizardStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./NotifyWizardStepTwo.vue?vue&type=style&index=0&id=36371f87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36371f87",
  null
  
)

export default component.exports